module.exports = __webpack_public_path__ + "img/symbol_4.ff7e9138.png";